'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var constants = require('ipfs-repo/constants');

function createVersion(_ref) {
  var repo = _ref.repo;

  function version() {
    return _version.apply(this, arguments);
  }

  function _version() {
    _version = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var options,
          match,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _context.prev = 1;
              _context.next = 4;
              return repo._checkInitialized(options);

            case 4:
              _context.next = 12;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              match = [/Key not found in database \[\/version\]/, /ENOENT/, /repo is not initialized yet/].some(function (m) {
                return m.test(_context.t0.message);
              });

              if (!match) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", constants.repoVersion);

            case 11:
              throw _context.t0;

            case 12:
              return _context.abrupt("return", repo.version.get());

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 6]]);
    }));
    return _version.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(version);
}

exports.createVersion = createVersion;